import * as SharedEnvironment from './environment.shared';

export const environment = {
    ...SharedEnvironment.environment,

    production: true,

    api: `https://api.staging.trianc.prior-it.be/`,

    sentryEnabled: true,
    sentryTracesSampleRate: 0.3,
    replaysSessionSampleRate: 0.1,
    sentryEnvironment: 'staging',
};

SharedEnvironment.injectEndpoints(environment);
SharedEnvironment.injectEnvironment(environment, 'staging');
